// extracted by mini-css-extract-plugin
module.exports = {"siteColor":"#29abe0"};